import { upgradeProductToTrialIds } from 'self-service-api/constants/Trials';
import TrialActivationButton from '../_core/trial/activation/TrialActivationButton';
import { TRIAL_STANDARD_DURATION } from '../_core/trial/constants';
import { useMultiTrialTrackingProps } from '../_core/trial/useMultiTrialTrackingProps';
import { sourceKeys } from '../_core/common/data/upgradeData/properties/sources';
import { getSource } from '../_core/common/data/upgradeData/transformers/getPropertySource';
import { mapPurchaseMotionApiName } from '../ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const updateUpgradeData = upgradeData => {
  const {
    app,
    screen,
    uniqueId,
    duration
  } = upgradeData;
  const isScreenUrlPath = screen.split('/').length > 1;
  const source = isScreenUrlPath ? uniqueId // Special case for UMS modals (uniqueId === upgradeKey)
  : getSource({
    app,
    screen,
    uniqueId
  }, sourceKeys.TRIAL_BUTTON);
  return Object.assign({}, upgradeData, {
    apiName: mapPurchaseMotionApiName(true, upgradeData.upgradeProduct, 'UITrialActivationButton', upgradeData.apiName),
    source,
    trialId: upgradeProductToTrialIds[upgradeData.upgradeProduct] || null,
    duration: duration || TRIAL_STANDARD_DURATION
  });
};
const UITrialActivationButton = props => {
  const {
    activeTrials,
    expiredTrials,
    isMultiTrial,
    isLoadingTrackingProps
  } = useMultiTrialTrackingProps();
  return /*#__PURE__*/_jsx(TrialActivationButton, {
    upgradeData: updateUpgradeData(props.upgradeData),
    block: props.block,
    activeTrials: activeTrials,
    expiredTrials: expiredTrials,
    isMultiTrial: isMultiTrial,
    isLoadingTrackingProps: isLoadingTrackingProps,
    use: props.use,
    onClick: props.onClick,
    level: props.level,
    isUpgradePoint: props.isUpgradePoint,
    dataSeleniumId: props['data-selenium-id'],
    onSuccess: props.onSuccess,
    onTrialStartSuccess: props.onTrialStartSuccess,
    children: props.children
  });
};
export default UITrialActivationButton;